/**
 * RequireRole — route guard. Defense-in-depth for the Staff-no-salary rule:
 * even though NAV_BY_ROLE hides the compensation group from STAFF, every salary
 * route is ALSO wrapped here so a hand-typed URL can't reach it.
 *
 * Pass `group` (the nav group the route belongs to) or `route` (a route id).
 * If the active role isn't allowed, redirect home.
 */
import { Navigate } from 'react-router-dom';
import type { ReactNode } from 'react';
import { useAuth } from '../hooks/useAuth';
import { isGroupAllowed, isRouteAllowed } from '../nav/config';

export function RequireRole({ group, route, children }: { group?: string; route?: string; children: ReactNode }) {
  const { role } = useAuth();
  const allowed = group ? isGroupAllowed(role, group) : route ? isRouteAllowed(role, route) : true;
  if (!allowed) return <Navigate to="/" replace />;
  return <>{children}</>;
}
